import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { compose } from 'ramda';
import { PublicPageLayout } from 'src/common/components/public-page-layout/public-page-layout';
import { withProviders } from 'src/common/hocs/with-providers';

import './blog-item.css';
import { BlogPostSkeleton } from './components/blog-post-skeleton/blog-post-skeleton';
import { BlogPost } from './components/blog-post/blog-post';
import { NotFound } from './components/not-found/not-found';
import { SocialSharing } from './components/social-sharing/social-sharing';
import { fetchBlogPostItem } from './state/blog-item-actions';
import { selectIsLoading, selectPostBySlug } from './state/blog-item-selectors';

const BlogItemComponent = ({ dispatch, isLoading, post, params }) => {
  const postUrl =
    post && !isLoading && !post.isError
      ? `https://streamable.com/${post.category.slug}/${post.slug}`
      : undefined;

  useEffect(() => {
    dispatch(fetchBlogPostItem(params.postSlug));
  }, [params.postSlug]);

  return (
    <PublicPageLayout hasSpecialOfferBanner>
      <Helmet>
        <title>{window._STM_PREDATA.blog.title}</title>
        <meta
          name="description"
          content={post ? post.summary : window._STM_PREDATA.blog.description}
        />
        <meta property="og:url" content={postUrl} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={post && post.title} />
        <meta property="og:description" content={post && post.summary} />
        <meta property="og:image" content={post && post.coverImage?.url} />
      </Helmet>

      <section className="blog-item">
        <div className="blog-item__content">
          {isLoading ? (
            <BlogPostSkeleton />
          ) : post !== undefined && !post.isError ? (
            <>
              <BlogPost post={post} />
              <SocialSharing url={postUrl} />
            </>
          ) : (
            <NotFound />
          )}
        </div>
      </section>
    </PublicPageLayout>
  );
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: selectIsLoading(state, ownProps.params.postSlug),
  post: selectPostBySlug(state, ownProps.params.postSlug),
});

export const BlogItem = compose(
  connect(mapStateToProps),
  withProviders({ isDarkModeSupported: false })
)(BlogItemComponent);
